// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__kPjx-","greenFill":"styles_greenFill__wVzvm","redFill":"styles_redFill__fLgqP","status":"styles_status__nVYKD"};